// extracted by mini-css-extract-plugin
module.exports = {"articles":"articles_articles__HVLVq","subheadline":"articles_subheadline__5a7qO","cards":"articles_cards__uAYq_"};